exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer {\n  margin-bottom: 10px; }\n\n.links {\n  padding-left: 30px;\n  color: #9c9b99; }\n\n.link {\n  color: #9c9b99; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agir/src/app/components/footer/footer.component.scss
// module id = ../../../../../src/app/components/footer/footer.component.scss
// module chunks = main